/* tslint:disable */
/* eslint-disable */

/**
 * 1 = InPlanung (In Planung)
 * 
 * 805290000 = InDurchfuhrung (In Durchführung)
 * 
 * 805290001 = Abgeschlossen (Abgeschlossen)
 * 
 * 805290002 = Storniert (Storniert)
 * 
 * 2 = Inaktiv (Inaktiv)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum AceAusschreibungAceAusschreibungEnumsAceAusschreibungStatuscode {
 InPlanung = 1,
 InDurchfuhrung = 805290000,
 Abgeschlossen = 805290001,
 Storniert = 805290002,
 Inaktiv = 2
}

marker([
    "Enum.AceAusschreibungAceAusschreibungEnumsAceAusschreibungStatuscode.InPlanung",
    "Enum.AceAusschreibungAceAusschreibungEnumsAceAusschreibungStatuscode.InDurchfuhrung",
    "Enum.AceAusschreibungAceAusschreibungEnumsAceAusschreibungStatuscode.Abgeschlossen",
    "Enum.AceAusschreibungAceAusschreibungEnumsAceAusschreibungStatuscode.Storniert",
    "Enum.AceAusschreibungAceAusschreibungEnumsAceAusschreibungStatuscode.Inaktiv"
]);

export namespace AceAusschreibungAceAusschreibungEnumsAceAusschreibungStatuscode
{
    class DataSets
    {
        static AceAusschreibungAceAusschreibungEnumsAceAusschreibungStatuscodeDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("InPlanung", 1, "In Planung"),
            new EnumValue("InDurchfuhrung", 805290000, "In Durchführung"),
            new EnumValue("Abgeschlossen", 805290001, "Abgeschlossen"),
            new EnumValue("Storniert", 805290002, "Storniert"),
            new EnumValue("Inaktiv", 2, "Inaktiv"),
        )
    }

    export function getAsDataset() {
        return DataSets.AceAusschreibungAceAusschreibungEnumsAceAusschreibungStatuscodeDataSet;
    }
}
